<div class="header">
  <h2>{{ "pages.analytics.events.title" | translate }}</h2>

  <div class="filters">
    <app-tutor-filter-control
      [analyticsPage]="'events'"
    ></app-tutor-filter-control>
    <app-date-range-control [analyticsPage]="'events'"></app-date-range-control>
  </div>
</div>

<div class="grid">
  <div class="col-span-4">
    <app-kpi-events-summary></app-kpi-events-summary>
  </div>
  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventSplit' | translate"
        [infoText]="'charts.descriptions.eventSplit' | translate"
        [isDemo]="analyticsService.isDemo('donutEventSplit')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-donut-event-split></app-donut-event-split>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventTypes' | translate"
        [infoText]="'charts.descriptions.eventTypes' | translate"
        [isDemo]="analyticsService.isDemo('multiLineEventTypes')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-multi-line-event-types></app-multi-line-event-types>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventHeatmap' | translate"
        [infoText]="'charts.descriptions.eventHeatmap' | translate"
        [isDemo]="analyticsService.isDemo('eventsHeatmap')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-heatmap-events></app-heatmap-events>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventExercisePerformance' | translate"
        [infoText]="'charts.descriptions.eventExercisePerformance' | translate"
        [isDemo]="analyticsService.isDemo('lineEventExercisePerformance')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-line-events-exercise-performance></app-line-events-exercise-performance>
    </nb-card-body>
  </nb-card>

  <nb-card class="card max-height">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventEngagementRatePerEntity' | translate"
        [infoText]="
          'charts.descriptions.eventEngagementRatePerEntity' | translate
        "
        [isDemo]="analyticsService.isDemo('hbarEngagementRatePerEntity')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-hbar-engagement-rate-per-entity></app-hbar-engagement-rate-per-entity>
    </nb-card-body>
  </nb-card>
  <nb-card class="card max-height">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventCountPerEntity' | translate"
        [infoText]="'charts.descriptions.eventCountPerEntity' | translate"
        [isDemo]="analyticsService.isDemo('hbarEventCountsPerEntity')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-hbar-event-counts-per-entity></app-hbar-event-counts-per-entity>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventPerSession' | translate"
        [infoText]="'charts.descriptions.eventPerSession' | translate"
        [isDemo]="analyticsService.isDemo('lineAvgEventsPerSession')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-line-avg-events-per-session></app-line-avg-events-per-session>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventEngagementRate' | translate"
        [infoText]="'charts.descriptions.eventEngagementRate' | translate"
        [isDemo]="analyticsService.isDemo('lineEventEngagementRate')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-line-event-engagement-rate></app-line-event-engagement-rate>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-2">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.eventThumbsPerEntity' | translate"
        [infoText]="'charts.descriptions.eventThumbsPerEntity' | translate"
        [isDemo]="analyticsService.isDemo('hstackThumbsPerEntity')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-hstack-thumbs-per-entity></app-hstack-thumbs-per-entity>
    </nb-card-body>
  </nb-card>
</div>
